<app-toolbar
  class="row w-100"
  [hideReportType]="true"
  (unitAppSelected)="getUnitProfileHistory($event)"
  (unitAppReport)="getUnitProfileReport($event)"
/>
@if (unitProfileHistoryData) {
  <kendo-grid
    class="col-12 mt-5 load-history-grid"
    [kendoGridBinding]="unitProfileHistoryData"
    [height]="600"
    [selectable]="true"
    [navigable]="true"
  >
    <kendo-grid-column>
      <ng-template let-dataItem kendoGridCellTemplate>
        <button
          *hasPermission="'UnitProfileDownload'"
          type="button"
          mat-button
          color="primary"
          class="me-3"
          [matTooltip]="'Download This Unit Profile as JSON'"
          (click)="download($event, dataItem.ID, 'json')"
        >
          <mat-icon class="me-2">file_download</mat-icon>JSON
        </button>
        <button
          *hasPermission="'UnitProfileDownload'"
          type="button"
          mat-button
          color="primary"
          class="me-3"
          [matTooltip]="'Download This Unit Profile as XML'"
          (click)="download($event, dataItem.ID, 'xml')"
        >
          <mat-icon class="me-2">file_download</mat-icon>XML
        </button>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="ChangeDate" title="Date" />
    <kendo-grid-column field="ID" title="ID" />
    <kendo-grid-column field="KBVersion" title="KB Version" />
    <kendo-grid-column field="Solution" title="Solution" />
    <kendo-grid-column field="UnitID" title="Unit ID" />
    <kendo-grid-column field="UserId" title="User" />
  </kendo-grid>
}
<ngx-loading [show]="loading" />
